import React from 'react'
import USTemplateDefault from 'src/components/template/us'
import { commonSubtitleText, commonTitleText } from 'src/modules/utils/constants'

export default (props) => {
  return (
    <USTemplateDefault
      location={props.location}
      lang="en"
      market="us"
      offerBanner={{
        title: ['Redeem your 30-day fubo PRO free trial', 'exclusive for Best Buy customers'],
      }}
      title={commonTitleText.streamLiveTVSports}
      subtitle={commonSubtitleText.onAnyDevice}
      ctaText="Get Started"
      showRSN={true}
      logo="https://assets-imgx.fubo.tv/marketing/lp/images/partners/fubo_bestbuy.png?w=450&ch=width&auto=format,compress"
      logoHeight="70px"
    />
  )
}
